import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FlashMessages, Message } from '@/lib/flashMessage/types';

const initialState: FlashMessages = { messages: [] };

const flashMessageSlice = createSlice({
  name: 'flashMessages',
  initialState,
  reducers: {
    addFlashMessage: (state: FlashMessages, action: PayloadAction<Message>) => {
      const message: Message = action.payload;
      if (!message.id) {
        message.id = `message-${Math.round(Math.random() * 999999)}`;
      }
      // The FlashMessage component only renders visible when isActive is true —
      // default it so callers can't accidentally dispatch an invisible message.
      message.isActive = message.isActive ?? true;
      state.messages.push(message);
    },
    removeFlashMessage: (
      state: FlashMessages,
      action: PayloadAction<Message>,
    ) => {
      state.messages = state.messages.filter(
        (message: Message) => message.id !== action.payload.id,
      );
    },
    dismissFlashMessage: (
      state: FlashMessages,
      action: PayloadAction<Message>,
    ) => {
      state.messages.forEach((message: Message) => {
        if (message.id === action.payload.id) {
          message.isActive = false;
        }
      });
    },
  },
});

export const { name, actions, reducer } = flashMessageSlice;
